module.exports = __webpack_public_path__ + "static/barge-zoom-d2bf9b2b75beb74bcaa27c30c5ee12b3.jpg";